import React, { FC } from 'react';
import cn from 'classnames';

import { default as Notification, Props as NotificationProps } from '../../../../../BaseComponents/Notification';
import { useTheme } from '../../../../../theme';

export interface Props {
	className?: string;
	status: NotificationProps['status'];
	title?: string;
	text?: React.ReactNode;
	actionText?: string;
	onClickAction?: () => void;
}

const ExchangeRefundOrderRequestStatus: FC<Props> = ({ className, status, title, text, actionText, onClickAction }) => {
	const { ExchangeRefundOrderRequestStatus: theme } = useTheme('Entities').Order;

	return (
		<Notification
			className={cn(theme.notification, className, { [theme.done]: status === 'done' })}
			globalClassName={theme.notificationGlobal}
			actionClassName={theme.action}
			type={'global'}
			status={status}
			title={title}
			text={text}
			actionText={actionText}
			onClickAction={onClickAction}
		/>
	);
};

export default ExchangeRefundOrderRequestStatus;
